'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-category-title {\n  color: #4179b8;\n  font-size: 14px;\n  line-height: 1.3em; }\n";
styleInject_es(css_248z);
